// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as React from "react";
import * as WorkUnit from "../../../../app/partner/entity/WorkUnit.bs.js";
import * as DateTime$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as WeeklyEarningsDetailsTable from "../../components/driver-earnings-list/WeeklyEarningsDetailsTable.bs.js";

function getOrderPickupTime(workUnit) {
  switch (workUnit.TAG | 0) {
    case /* Order */0 :
        return workUnit._1.pickupTime;
    case /* Login */1 :
    case /* Mbg */2 :
        return -1;
    
  }
}

function getView(weeklyEarnings) {
  var sortedEarnings = List.sort((function (firstRecord, secondRecord) {
          var isEqual = 1;
          if (DateTime$Catalyst.isAfter(firstRecord.date, secondRecord.date)) {
            isEqual = 1;
          } else if (DateTime$Catalyst.isBefore(firstRecord.date, secondRecord.date)) {
            isEqual = -1;
          } else if (WorkUnit.toString(firstRecord.workUnit) === "ORDER" && WorkUnit.toString(secondRecord.workUnit) === "ORDER") {
            isEqual = getOrderPickupTime(firstRecord.workUnit) > getOrderPickupTime(secondRecord.workUnit) ? 1 : -1;
          } else if (WorkUnit.toString(firstRecord.workUnit) === "ORDER") {
            isEqual = 1;
          } else if (WorkUnit.toString(secondRecord.workUnit) === "ORDER") {
            isEqual = -1;
          } else if (WorkUnit.toString(firstRecord.workUnit) === "LOGIN") {
            isEqual = 1;
          } else if (WorkUnit.toString(secondRecord.workUnit) === "LOGIN") {
            isEqual = -1;
          }
          return isEqual;
        }), weeklyEarnings.weeklyEarnings);
  return React.createElement(WeeklyEarningsDetailsTable.make, {
              tableData: sortedEarnings
            });
}

var WeeklyEarningsDetailsViewMapper = {
  getView: getView
};

export {
  WeeklyEarningsDetailsViewMapper ,
  
}
/* react Not a pure module */
